import type { DataSource, Entity, WildfireEntity } from '../types/entity';
import { apiFetch } from '../lib/apiFetch';

/**
 * Client desta camada nunca fala com a NASA FIRMS diretamente — sempre
 * via proxy `/api/firms` (Cloud Function), que segura a key e normaliza
 * o CSV upstream pra JSON. Ver functions/src/proxies/firms.ts.
 */

interface FirmsProxyDetection {
  latitude: number;
  longitude: number;
  brightnessK: number;
  frp: number | null;
  confidence: 'low' | 'nominal' | 'high';
  satellite: string;
  acquiredAt: string;
}

interface FirmsProxyResponse {
  detections: FirmsProxyDetection[];
}

function toWildfireEntity(d: FirmsProxyDetection, index: number): WildfireEntity {
  return {
    id: `wildfire-${d.acquiredAt}-${d.latitude}-${d.longitude}-${index}`,
    layer: 'wildfires',
    lat: d.latitude,
    lon: d.longitude,
    label: `Foco de calor — ${d.confidence}`,
    severity: d.confidence === 'high' ? 'critical' : 'normal',
    observedAt: d.acquiredAt,
    raw: {
      brightnessK: d.brightnessK,
      frp: d.frp,
      confidence: d.confidence,
      satellite: d.satellite,
    },
  };
}

export const wildfiresSource: DataSource = {
  layer: 'wildfires',
  label: 'Incêndios (NASA FIRMS)',
  requiresClientKey: false,
  viaCloudFunction: true,

  async fetchEntities(): Promise<Entity[]> {
    const res = await apiFetch('/firms');
    if (!res.ok) {
      throw new Error(`Proxy FIRMS respondeu ${res.status}`);
    }

    const data = (await res.json()) as FirmsProxyResponse;
    return data.detections.map(toWildfireEntity);
  },
};
